import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c84ac2da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "users" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-label sub-heading" }, "カテゴリ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-label sub-heading" }, "質問", -1))
const _hoisted_4 = ["disabled"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-label sub-heading" }, "解答", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Q&A作成 ")

import { ref, withDefaults , watch } from "vue";
import { QuillEditor } from '@vueup/vue-quill'
import { ElMessage } from 'element-plus'
import CategoryList from "@/components/common/categories/CategoryList.vue"
import QuestionFiles from "@/components/question/QuestionFiles.vue"
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import BlotFormatter from 'quill-blot-formatter'
import ImageCompress from 'quill-image-compress'
import MagicUrl from 'quill-magic-url'
import { Category } from '@/types/category'
import { QuestionCategory } from "@/types/question_category"
interface Props {
  modelValue: boolean;
  categoryList: QuestionCategory[];
  defaultCategoryId: number;
  disableForm: boolean;
  loading: boolean;
}
// const props = defineProps<Props>();
interface Emits {
  (e: "addQuestion", _categoryId: number, _body: string, _answer: string, _files: File[]): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, required: true },
    categoryList: { type: Array, required: true },
    defaultCategoryId: { type: Number, required: true },
    disableForm: { type: Boolean, required: true, default: false },
    loading: { type: Boolean, required: true, default: false }
  },
  emits: ["addQuestion"],
  setup(__props: any, { emit }: { emit: ({
  (e: "addQuestion", _categoryId: number, _body: string, _answer: string, _files: File[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, categoryList: QuestionCategory[], defaultCategoryId: number, disableForm: boolean, loading: boolean }
const toolber = [
  ['bold', 'italic', 'underline'],
  [{ 'color': [] }, { 'background': [] }],
  ['link'],
  ['image'],
];
const modules = [{
  name: 'blotFormatter',
  module: BlotFormatter,
  options: {/* options */ }
},
{
  name: 'MagicUrl',
  module: MagicUrl,
  options: {/* options */ }
},
{
  name: 'ImageCompress',
  module: ImageCompress,
  options: {
    quality: 0.9,
    maxWidth: 1500,
    maxHeight: 1500,
    imageType: 'image/jpeg',
    debug: false,
    suppressErrorLogging: false, // default
  }
}
]
const quillOptions = {
  debug: 'error'
}




const categoryId = ref(0);
watch(() => props.defaultCategoryId, (id) => {
  categoryId.value = id;
});
let body = ref("");
let answer = ref("");
let answerEditor: any = ref(null);
const fileList = ref<File[]>([])
// let disable = computed(() => props.disableForm);
const createQuestion = () => {
  const answer_html = answerEditor.value.getHTML()
  const size = answer_html.length / 1024 / 1024
  // 5MB以上はだめにする
  if (size > 5) {
    ElMessage.error({
      message: '登録するQAのサイズは5MBまでになります',
      dangerouslyUseHTMLString: true,
      showClose: true,
      duration: 0
    });
    return
  }

  emit("addQuestion", categoryId.value, body.value, answer_html, fileList.value);
  body.value = "";
  answerEditor.value.setText("")
  fileList.value = []
};

const setMoveCategoryId = (category: Category) => {
  categoryId.value = category.id;
}

return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_dialog, {
      title: "新規追加",
      "model-value": __props.modelValue,
      width: "30%",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: createQuestion,
          disabled: __props.disableForm || categoryId.value == 0 || _unref(body).length == 0 || _unref(answer).replace(/<p>|<\/p>|<br>/g, '').length == 0
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_el_card, {
            shadow: "never",
            class: "category-list"
          }, {
            default: _withCtx(() => [
              _createVNode(CategoryList, {
                onListClick: setMoveCategoryId,
                categories: __props.categoryList,
                hideAll: true,
                currentNodeKey: __props.defaultCategoryId,
                expandNodeKey: [__props.defaultCategoryId ?? 0]
              }, null, 8, ["categories", "currentNodeKey", "expandNodeKey"])
            ]),
            _: 1
          }),
          _hoisted_3,
          _withDirectives(_createElementVNode("textarea", {
            class: "textarea",
            disabled: __props.disableForm,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(body) ? (body).value = $event : body = $event)),
            rows: "5"
          }, null, 8, _hoisted_4), [
            [_vModelText, _unref(body)]
          ]),
          _hoisted_5,
          _createVNode(_unref(QuillEditor), {
            ref: (_value, _refs) => {
              _refs['answerEditor'] = _value
              _isRef(answerEditor) ? answerEditor.value = _value : answerEditor = _value
            },
            theme: "snow",
            disabled: __props.disableForm,
            toolbar: toolber,
            globalOptions: quillOptions,
            modules: modules,
            content: _unref(answer),
            "onUpdate:content": _cache[1] || (_cache[1] = ($event: any) => (_isRef(answer) ? (answer).value = $event : answer = $event)),
            contentType: 'html'
          }, null, 8, ["disabled", "content"]),
          _createVNode(QuestionFiles, {
            modelValue: fileList.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fileList).value = $event))
          }, null, 8, ["modelValue"])
        ], 512), [
          [_directive_loading, __props.loading]
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})